'use client';

import { c as _c } from "react/compiler-runtime";
import { ImportQueueRail } from '@lib/import-queue-ui/components/import-queue-rail';
import { useInsightsBulkImportController } from '@lib/insights/bulk-import/hooks/use-insights-bulk-import-controller';
import { useListingImportController } from '@lib/listing-import/hooks/use-listing-import-controller';
import { useTemplateBulkImportController } from '@lib/templates/bulk-import/hooks/use-template-bulk-import-controller';
export function GlobalImportRail() {
  const $ = _c(4);
  const templateController = useTemplateBulkImportController();
  const insightsController = useInsightsBulkImportController();
  const listingsController = useListingImportController();
  let t0;
  if ($[0] !== insightsController || $[1] !== listingsController || $[2] !== templateController) {
    t0 = <ImportQueueRail controllers={[templateController, insightsController, listingsController]} data-sentry-element="ImportQueueRail" data-sentry-component="GlobalImportRail" data-sentry-source-file="global-import-rail.tsx" />;
    $[0] = insightsController;
    $[1] = listingsController;
    $[2] = templateController;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}